import * as React from "react";
import { forwardRef } from "react";
const SvgFiscal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M6 9L8 9",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6 12L8 12",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M6 15L14 15",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18 3C18.9665 3 20 3.5 20 4.78736C20 5.31427 20 9.5 20 9.5H17M18 3C17.0335 3 17 3.80023 17 4.78736V9.5M18 3H5.5C4.11929 3 3 4.14318 3 5.55337V17.7929C3 17.9255 3.05268 18.0527 3.14645 18.1464L4.64645 19.6464C4.84171 19.8417 5.15829 19.8417 5.35355 19.6464L6.64645 18.3536C6.84171 18.1583 7.15829 18.1583 7.35355 18.3536L8.64645 19.6464C8.84171 19.8417 9.15829 19.8417 9.35355 19.6464L11 18L12.6464 19.6464C12.8417 19.8417 13.1583 19.8417 13.3536 19.6464L14.6464 18.3536C14.8417 18.1583 15.1583 18.1583 15.3536 18.3536L16.1464 19.1464C16.4614 19.4614 17 19.2383 17 18.7929V9.5",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11 9.85714L12.0909 11L14 9",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgFiscal);
export default ForwardRef;
